import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import CumulativePerformance from "./CumulativePerformance";
import HistoricalPerformance from "./HistoricalPerformance";
import Information from "./Information";
import MeasuresTable from "./MeasuresTable";

import "./style.scss";

function InfoDetails({
  KPIDetails,
  locale,
  intl,
  getData,
  isPermitiveUpdate,
  kpisStatus,
}) {
  useEffect(() => {
    getData();
  }, []);

  const theme = useSelector((store) => store.theme);

  return (
    <div className="kpi-info-details">
      <div
        className="kpi-info-details_charts-containers"
        style={{ direction: "ltr" }}
      >
        <HistoricalPerformance
          item={KPIDetails}
          locale={locale}
          theme={theme}
          kpisStatus={kpisStatus}
        />
        <CumulativePerformance
          item={KPIDetails}
          locale={locale}
          theme={theme}
          intl={intl}
          getData={getData}
          isPermitiveUpdate={isPermitiveUpdate}
        />
      </div>
      <Information item={KPIDetails} locale={locale} theme={theme} />
      <MeasuresTable item={KPIDetails} />
    </div>
  );
}

export default InfoDetails;
